import {
  Controller,
} from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (this.element.classList.contains('hidden')) this.startCounter();
    this.listener = () => { this.startCounter() };
    document.addEventListener('click', this.listener);
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval);
    document.removeEventListener('click', this.listener);
  }

  startCounter() {
    this.timeout = 30;
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.timeout -= 1;
      if (this.timeout < 0) {
        clearInterval(this.interval);
        this.interval = null;
        this.element.classList.remove('hidden');
        const modalWrapper = document.querySelector('turbo-frame#modal');
        if (modalWrapper) modalWrapper.innerHTML = '';
        this.element.classList.remove('hidden');
      }
    }, 1000);
  }

  hide() {
    this.element.classList.add('hidden');
  }
}
